import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import {
  allMainNavItems,
  allEdgesNavItems,
  allAdminItems,
  helpNavItems,
  extraTitleRoutes,
} from "@/lib/navItems";

const BRAND = "SimCheck";

const ALL_ROUTES: { url: string; title: string }[] = [
  ...allMainNavItems,
  ...allEdgesNavItems,
  ...allAdminItems,
  ...helpNavItems,
  ...extraTitleRoutes,
].map(({ url, title }) => ({ url, title }));

function findPageLabel(pathname: string): string | null {
  const exact = ALL_ROUTES.find(r => r.url === pathname);
  if (exact) return exact.title;

  // Longest-prefix match for nested routes (e.g. /flows/:id → "Flows",
  // /admin/users/abc → "Users"). The "/" entry is exact-only.
  const prefixes = ALL_ROUTES.filter(r => r.url !== "/" && pathname.startsWith(r.url + "/"));
  if (prefixes.length === 0) return null;
  prefixes.sort((a, b) => b.url.length - a.url.length);
  return prefixes[0].title;
}

export function useDocumentTitle() {
  const { activeOrganization, isViewingAsOrg, viewedAsOrg, isSuperAdmin } = useAuth();
  const { pathname } = useLocation();

  const orgName = isViewingAsOrg && viewedAsOrg
    ? viewedAsOrg.name
    : activeOrganization?.name
      ?? (isSuperAdmin && pathname.startsWith("/admin") ? "Super Admin" : null);

  const pageLabel = findPageLabel(pathname);

  useEffect(() => {
    const parts = [orgName, pageLabel, BRAND].filter(Boolean);
    document.title = parts.join(" · ");
  }, [orgName, pageLabel]);
}
